import moment from 'moment-timezone';

export const buildRollingRequestDateRange = (periodInDays, today = moment()) => {
  const end = moment(today);
  const normalizedPeriod = Math.max(Number(periodInDays) || 1, 1);
  const start = end.clone().subtract(normalizedPeriod - 1, 'days');

  return {
    startDate: start.format('YYYY-MM-DD'),
    endDate: end.format('YYYY-MM-DD'),
  };
};
